// extracted by mini-css-extract-plugin
export default {"readMoreContent":"ReadMore_readMoreContent__v6z45","collapsed":"ReadMore_collapsed__cmHd8"};